import React, { useEffect } from 'react';

import { useExchangeRate } from '$contexts/exchange-rate';
import BaseSelect from '$partials/fields/select.jsx';
import { usePersistedCookieState } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').CurrencySelector}
 */
const CurrencySelector = ({
    className,
    pageTitle
}) => {
    const {
        currency,
        setCurrency
    } = useExchangeRate();

    const {
        value: currencyCookie,
        setValue: setCurrencyCookie,
    } = usePersistedCookieState('GBP', `${pageTitle}_currency_cookie`);

    useEffect(() => {
        if (currencyCookie !== currency) {
            setCurrency(currencyCookie);
        }
    }, [currencyCookie, currency, setCurrency]);

    const currencyOptions = [
        { label: 'GBP', value: 'GBP' },
        { label: 'EUR', value: 'EUR' },
        { label: 'USD', value: 'USD' },
        { label: 'ILS', value: 'ILS' },
    ];

    return (
        <BaseSelect
            displayValue={currencyOptions.find((opt) => opt.value === currency)?.label}
            name='currency'
            onChange={(selectedCurrency) => {
                setCurrency(selectedCurrency);
                setCurrencyCookie(selectedCurrency);
            }}
            options={currencyOptions}
            triggerClassName={className}
            value={currency} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default CurrencySelector;
